<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">

            <el-form-item label="船舶名称:" prop="shipName">
              <el-input  placeholder="" v-model="searchFrom.shipName"></el-input>
            </el-form-item>
            <el-form-item label="船舶识别号:" prop="shipNo">
              <el-input  placeholder="" v-model="searchFrom.shipNo"></el-input>
            </el-form-item>
            <el-form-item label="创建人:" prop="createUserName">
              <el-input  placeholder="" v-model="searchFrom.createUserName"></el-input>
            </el-form-item>
            <el-form-item label="船舶标识:" prop="shipInfoFlag">
              <el-select  v-model="searchFrom.shipInfoFlag"   placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="普通船舶" value="1"></el-option>
                <el-option label="理货船舶" value="2"></el-option>
              </el-select>
            </el-form-item>
                <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item  btnCode="00KP002B001"  v-if="btnFlg[0]">
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item  btnCode="00KP002B002"  v-if="btnFlg[1]">
            <el-button type="primary" @click="delDeiver">删除</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="00KP002B003"  v-if="btnFlg[2]" @click="modifyRegion(scope.row)">修改</el-button>
              <el-button type="text" size="mini" btnCode="00KP002B003"   @click="detailFn(scope.row)">详情</el-button>
            </template>
        </el-table-column>
        <el-table-column property="shipInfoFlag" width="140" label="船舶标识">
          <template scope="scope">
            {{[ "普通船舶", "理货船舶" ][scope.row.shipInfoFlag-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="shipName"  width="160" :formatter="emptyFn" label="船舶名称"></el-table-column>
        <el-table-column prop="shipNo"  width="160" :formatter="emptyFn" label="船舶识别号"></el-table-column>
         <el-table-column prop="shipOwner"  width="160" :formatter="emptyFn" label="船舶所有人"></el-table-column>
        <el-table-column property="type" width="160" label="船舶尺寸(米)" >
          <template scope="scope">
            {{scope.row.length}}*{{scope.row.width}}*{{scope.row.height}}
          </template>
        </el-table-column>
        <el-table-column prop="noLoadDraft"  width="120" :formatter="emptyFn" label="空载吃水(m)"></el-table-column>
        <el-table-column prop="fullDraft"  width="120" :formatter="emptyFn" label="满载吃水(m)"></el-table-column>
         <el-table-column prop="noLoadDisplacement"  width="120" :formatter="emptyFn" label="空载排水量(吨)"></el-table-column>
          <el-table-column prop="fullDisplacement"  width="120" :formatter="emptyFn" label="满载排水量(吨)"></el-table-column>
         <el-table-column prop="referenceCapacity"  width="120" :formatter="emptyFn" label="参考载货量(吨)"></el-table-column>
        <el-table-column prop="launchDate" width="120" :formatter="dateFormat" label="建造完工日期"></el-table-column>
       <el-table-column prop="nationality" :formatter="emptyFn" label="所属国籍"></el-table-column>
       <el-table-column prop="createUserName" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="1000px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class="inpBox">
          <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶基本资料</span>
              </h4>
              <div>
            <el-form-item prop="shipInfoFlag" label="船舶标识">
              <el-select v-model="addFrom.shipInfoFlag" placeholder="请选择" @change="flagchange">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
                <el-form-item label="船舶名称:" prop="shipName">
                  <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipName"  @blur="blurFn()"></el-input>
                </el-form-item>
                <el-form-item label="船舶识别号:" prop="shipNo" :rules="addFrom.shipInfoFlag == 1 ? rules.shipNo:[{required: false}]">
                  <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipNo"></el-input>
                </el-form-item>
                <!-- <el-form-item label="船舶识别号:" prop="shipNo"  :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" :rules="addFrom.shipInfoFlag == 1 ? rules.shipNo:[{required: false}]">
                  <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipNo" @blur="blurFn()"></el-input>
                </el-form-item> -->
                <el-form-item label="所属国籍:" prop="nationality" :rules="addFrom.shipInfoFlag == 1 ? rules.nationality:[{required: false}]" >
                  <el-input  placeholder=""     maxlength="8"   v-model="addFrom.nationality"></el-input>
                </el-form-item>
                <el-form-item label="船舶类型:" prop="shipType" :rules="addFrom.shipInfoFlag == 1 ? rules.shipType:[{required: false}]">
                  <el-input  placeholder=""     maxlength="8"   v-model="addFrom.shipType"></el-input>
                </el-form-item>
                <el-form-item label="建造完工日期:" prop="launchDate" :rules="addFrom.shipInfoFlag == 1 ? rules.launchDate:[{required: false}]">
                <el-date-picker
                    v-model="addFrom.launchDate"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
                    type="date"
                    :picker-options="pickerOptions"
                      placeholder="选择日期时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="呼号:" prop="shipCall" :rules="addFrom.shipInfoFlag == 1 ? rules.shipCall:[{required: false}]">
                  <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipCall"></el-input>
                </el-form-item>
                 <el-form-item label="船舶经营人:" prop="shipOperator" :rules="addFrom.shipInfoFlag == 1 ? rules.shipOperator:[{required: false}]">
                  <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipOperator"></el-input>
                </el-form-item>
                <el-form-item label="船舶所有人:" prop="shipOwner" :rules="addFrom.shipInfoFlag == 1 ? rules.shipOwner:[{required: false}]">
                  <el-input  placeholder="" maxlength="20"  v-model="addFrom.shipOwner"></el-input>
                </el-form-item>
                <!-- <el-form-item label="货物类型:" prop="shipType">
                  <el-select  v-model="addFrom.shipType"  placeholder="请选择">
                    <el-option  label="item.name" value="item" :></el-option>
                  </el-select>
                </el-form-item> -->
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船体信息</span>
              </h4>
              <div>
               <el-form-item label="总长:" prop="totalLength" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.totalLength:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="2"   maxlength="8"   v-model="addFrom.totalLength"></el-input>
                <span class="danwei">m</span>
              </el-form-item>
                <el-form-item label="船长:" prop="length" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.length:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="2"   maxlength="8"   v-model="addFrom.length"></el-input>
                <span class="danwei">m</span>
              </el-form-item>
              <el-form-item label="船宽:" prop="width" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.width:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="2"   maxlength="8"   v-model="addFrom.width"></el-input>
                <span class="danwei">m</span>
              </el-form-item>
              <el-form-item label="型深:" prop="height" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.height:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="2"   maxlength="8"   v-model="addFrom.height"></el-input>
                <span class="danwei">m</span>
              </el-form-item>
              <el-form-item label="空载吃水:" prop="noLoadDraft" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.noLoadDraft:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="3"   maxlength="8"   v-model="addFrom.noLoadDraft"></el-input>
                <span class="danwei">m</span>
              </el-form-item>
              <el-form-item label="满载吃水:" prop="fullDraft" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.fullDraft:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="3"   maxlength="8"   v-model="addFrom.fullDraft"></el-input>
                <span class="danwei">m</span>
              </el-form-item>
              <el-form-item label="空载排水量:" prop="noLoadDisplacement" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.noLoadDisplacement:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="3"   maxlength="8"   v-model="addFrom.noLoadDisplacement"></el-input>
                <span class="danwei">吨</span>
              </el-form-item>
              <el-form-item label="满载排水量:" prop="fullDisplacement" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.fullDisplacement:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="3"   maxlength="8"   v-model="addFrom.fullDisplacement"></el-input>
                <span class="danwei">吨</span>
              </el-form-item>
              <el-form-item label="参考载货量:" prop="referenceCapacity" class="jiage" :rules="addFrom.shipInfoFlag == 1 ? rules.referenceCapacity:[{required: false}]">
                <el-input  placeholder=""  v-number-input.float="3"   maxlength="8"   v-model="addFrom.referenceCapacity"></el-input>
                <span class="danwei">吨</span>
              </el-form-item>
             <el-form-item label="航区:" prop="navigationArea" :rules="addFrom.shipInfoFlag == 1 ? rules.navigationArea:[{required: false}]">
                <el-input  placeholder=""     maxlength="8"   v-model="addFrom.navigationArea"></el-input>
              </el-form-item>
              <el-form-item label="货仓数量:" prop="warehouseQuantity" :rules="addFrom.shipInfoFlag == 1 ? rules.warehouseQuantity:[{required: false}]">
                <el-input  placeholder=""   v-number-input.float="0"   maxlength="8"   v-model="addFrom.warehouseQuantity"></el-input>
              </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船东信息</span>
              </h4>
              <div>
                  <el-form-item label="公司名称:" >
                    <el-input  placeholder="" maxlength="20"  v-model="addFrom.extList[0].companyName"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人:" >
                    <el-input  placeholder="" maxlength="20" v-model="addFrom.extList[0].contactsName"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人电话:" prop="captainPhone">
                    <el-input  placeholder="" maxlength="11" v-number-input.float="0"    v-model="addFrom.extList[0].contactsPhone"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人邮箱:" prop="extList.0.contactsEmail"   :rules="rules.contactsEmail">
                    <el-input  placeholder="" maxlength="20"   v-model="addFrom.extList[0].contactsEmail"></el-input>
                  </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船长信息</span>
              </h4>
              <div>
                <el-form-item label="公司名称:" >
                    <el-input  placeholder="" maxlength="20"  v-model="addFrom.extList[1].companyName"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人:" >
                    <el-input  placeholder="" maxlength="20" v-model="addFrom.extList[1].contactsName"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人电话:" prop="captainPhone">
                    <el-input  placeholder=""  maxlength="11" v-number-input.float="0"    v-model="addFrom.extList[1].contactsPhone"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人邮箱:" prop="extList.1.contactsEmail"   :rules="rules.contactsEmail">
                    <el-input  placeholder="" maxlength="20"   v-model="addFrom.extList[1].contactsEmail"></el-input>
                  </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船代信息</span>
              </h4>
              <div>
                <el-form-item label="公司名称:" >
                    <el-input  placeholder="" maxlength="20"  v-model="addFrom.extList[2].companyName"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人:" >
                    <el-input  placeholder="" maxlength="20" v-model="addFrom.extList[2].contactsName"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人电话:" prop="captainPhone">
                    <el-input  placeholder=""  maxlength="11" v-number-input.float="0"   v-model="addFrom.extList[2].contactsPhone"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人邮箱:" prop="extList.2.contactsEmail"   :rules="rules.contactsEmail">
                    <el-input  placeholder="" maxlength="20"   v-model="addFrom.extList[2].contactsEmail"></el-input>
                  </el-form-item>
              </div>
            </div>
            <div class="addressBox" v-if="dialogVisible">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶图片</span>
              </h4>
              <div>
                  <div class="imgBox">
                    <uploadImgs :imgList.sync='imgList' :max=5 @remove='remove'></uploadImgs>
                </div>
              </div>
            </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 详情 -->
    <el-dialog  :title="title"  :close-on-click-modal="false" :close-on-press-escape="false" class="detail"  @close="closeDialog"   :visible.sync="dialogDetail" width="1000px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class="inpBox">
          <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶基本资料</span>
              </h4>
              <div>
                <el-form-item label="船舶标识:" prop="shipInfoFlag">
                  {{addFrom.shipInfoFlag==1 ? '普通船舶' : '理货船舶'}}
                 <!-- <span v-if="addFrom.shipInfoFlag==1">普通船舶</span>
                 <span v-else>理货船舶</span> -->
                </el-form-item>
                <el-form-item label="船舶名称:" prop="shipName">
                 <span>{{addFrom.shipName}}</span>
                </el-form-item>
                <el-form-item label="所属国籍:" prop="nationality" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
                  <span>{{addFrom.nationality ? addFrom.nationality : '-'}}</span>
                </el-form-item>
                <el-form-item label="船舶类型:" prop="shipType" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
                  <span>{{addFrom.shipType ? addFrom.shipType : '-'}}</span>
                </el-form-item>
                <el-form-item label="船舶识别号:" prop="shipNo" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
                  <span>{{addFrom.shipNo ? addFrom.shipNo : '-'}}</span>
                </el-form-item>
                <el-form-item label="建造完工日期:" prop="launchDate" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
                  <span>{{addFrom.launchDate|dateFormat1}}</span>
                </el-form-item>
                <el-form-item label="呼号:" prop="shipCall" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
                  <span>{{addFrom.shipCall ? addFrom.shipCall : '-'}}</span>
                </el-form-item>
                 <el-form-item label="船舶经营人:" prop="shipOperator" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
                  <span>{{addFrom.shipOperator ? addFrom.shipOperator : '-'}}</span>
                </el-form-item>
                <el-form-item label="船舶所有人:" prop="shipOwner" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
                  <span>{{addFrom.shipOwner ? addFrom.shipOwner : '-'}}</span>
                </el-form-item>
                <!-- <el-form-item label="货物类型:" prop="shipType">
                  <el-select  v-model="addFrom.shipType"  placeholder="请选择">
                    <el-option  label="item.name" value="item" :></el-option>
                  </el-select>
                </el-form-item> -->
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船体信息</span>
              </h4>
              <div>
               <el-form-item label="总长:" prop="totalLength" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
                <span >{{addFrom.totalLength ? addFrom.totalLength + ' m' : '-'}}</span>
              </el-form-item>
                <el-form-item label="船长:" prop="length" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
                <span >{{addFrom.length ? addFrom.length + ' m' : '-'}}</span>
              </el-form-item>
              <el-form-item label="船宽:" prop="width" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
                <span >{{addFrom.width ? addFrom.width + ' m' : '-'}}</span>
              </el-form-item>
              <el-form-item label="型深:" prop="height" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
               <span >{{addFrom.height ? addFrom.height + ' m' : '-'}}</span>
              </el-form-item>
              <el-form-item label="空载吃水:" prop="noLoadDraft" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
               <span >{{addFrom.noLoadDraft ? addFrom.noLoadDraft + ' m' : '-'}}</span>
              </el-form-item>
              <el-form-item label="满载吃水:" prop="fullDraft" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
                <span >{{addFrom.fullDraft ? addFrom.fullDraft + ' m' : '-'}}</span>
              </el-form-item>
              <el-form-item label="空载排水量:" prop="noLoadDisplacement" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
                <span >{{addFrom.noLoadDisplacement ? addFrom.noLoadDisplacement + ' 吨' : '-'}}</span>
              </el-form-item>
              <el-form-item label="满载排水量:" prop="fullDisplacement" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
               <span >{{addFrom.fullDisplacement ? addFrom.fullDisplacement + ' 吨' : '-'}}</span>
              </el-form-item>
              <el-form-item label="参考载货量:" prop="referenceCapacity" :class="{'NOcommon': addFrom.shipInfoFlag!=1}">
               <span >{{addFrom.referenceCapacity ? addFrom.referenceCapacity + ' 吨' : '-'}}</span>
              </el-form-item>
             <el-form-item label="航区:" prop="navigationArea" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
               <span >{{addFrom.navigationArea ? addFrom.navigationArea : '-'}}</span>
              </el-form-item>
              <el-form-item label="货仓数量:" prop="warehouseQuantity" :class="{ 'NOcommon': addFrom.shipInfoFlag!=1 }">
               <span>{{addFrom.warehouseQuantity ? addFrom.warehouseQuantity : '-'}}</span>
              </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船东信息</span>
              </h4>
              <div>
                   <el-form-item label="公司名称:" >
                    <span>{{addFrom.extList[0].companyName?addFrom.extList[0].companyName:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人:" >
                    <span>{{addFrom.extList[0].contactsName?addFrom.extList[0].contactsName:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人电话:" prop="captainPhone1">
                    <span>{{addFrom.extList[0].contactsPhone?addFrom.extList[0].contactsPhone:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人邮箱:" prop="contactsEmail0">
                    <span>{{addFrom.extList[0].contactsEmail?addFrom.extList[0].contactsEmail:'-'}}</span>
                  </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船长信息</span>
              </h4>
              <div>
                <el-form-item label="公司名称:" >
                    <span>{{addFrom.extList[1].companyName?addFrom.extList[1].companyName:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人:" >
                    <span>{{addFrom.extList[1].contactsName?addFrom.extList[1].contactsName:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人电话:" prop="captainPhone1">
                    <span>{{addFrom.extList[1].contactsPhone?addFrom.extList[1].contactsPhone:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人邮箱:" prop="contactsEmail1">
                    <span>{{addFrom.extList[1].contactsEmail?addFrom.extList[1].contactsEmail:'-'}}</span>
                  </el-form-item>
              </div>
            </div>
            <hr>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船代信息</span>
              </h4>
              <div>
                  <el-form-item label="公司名称:" >
                    <span>{{addFrom.extList[2].companyName?addFrom.extList[2].companyName:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人:" >
                    <span>{{addFrom.extList[2].contactsName?addFrom.extList[2].contactsName:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人电话:" prop="captainPhone1">
                    <span>{{addFrom.extList[2].contactsPhone?addFrom.extList[2].contactsPhone:'-'}}</span>
                  </el-form-item>
                  <el-form-item label="联系人邮箱:" prop="contactsEmail2">
                    <span>{{addFrom.extList[2].contactsEmail?addFrom.extList[2].contactsEmail:'-'}}</span>
                  </el-form-item>
              </div>
            </div>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>船舶图片</span>
              </h4>
             <div class="imgBox">
                <el-image
                  v-for="(item,index) in zhanshiList" :src="item" :key="index"
                  style="width: 290px; height: 200px ; margin-right: 30px;"
                  :preview-src-list="getSrcList(index,zhanshiList)">
                </el-image>
            </div>
            </div>

        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { cShipInfoAdd, cShipInfoList, cShipInfoUpdate, cShipInfoDelete, cShipInfoDetail } from '@/api/shipping'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
export default {
  components: {
    uploadImgs
  },
  data () {
    return {
      options: [{
        value: 1,
        label: '普通船舶'
      }, {
        value: 2,
        label: '理货船舶'
      }],
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      title: '新建',
      dialogVisible: false,
      dialogDetail: false,
      checkList: [],
      tableList: [],
      types: [
        { name: '请选择', id: '' },
        { name: '收货地址', id: 1 },
        { name: '发货地址', id: 2 }
      ],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        shipInfoFlag: [
          { required: true, message: '请选择船舶标识', trigger: 'blur' }
        ],
        shipName: [
          { required: true, message: '请输入船舶名称', trigger: 'blur' }
        ],
        shipType: [
          { required: true, message: '请输入船舶类型', trigger: 'blur' }
        ],
        shipCall: [
          { required: true, message: '请输入呼号', trigger: 'blur' }
        ],
        shipNo: [
          { required: true, message: '请输入船舶识别号', trigger: 'blur' }
        ],
        shipOperator: [
          { required: true, message: '请输入船舶经营人', trigger: 'blur' }
        ],
        totalLength: [
          { required: true, message: '请输入总长', trigger: 'blur' }
        ],
        warehouseQuantity: [
          { required: true, message: '请输入货仓数量', trigger: 'blur' }
        ],
        length: [
          { required: true, message: '请输入船长', trigger: 'blur' }
        ],
        width: [
          { required: true, message: '请输入船宽', trigger: 'blur' }
        ],
        height: [
          { required: true, message: '请输入型深', trigger: 'blur' }
        ],
        nuclearLoadWeight: [
          { required: true, message: '请输入核载重量', trigger: 'blur' }
        ],
        referenceCapacity: [
          { required: true, message: '请输入参考载货量', trigger: 'blur' }
        ],
        launchDate: [
          { required: true, message: '请选择下水日期', trigger: 'blur' }
        ],
        nationality: [
          { required: true, message: '请输入船籍', trigger: 'blur' }
        ],
        shipOwner: [
          { required: true, message: '请输入船舶所有人', trigger: 'blur' }
        ],
        shipOwnerPhone: [
          this.rule.mobile
        ],
        captainPhone: [
          this.rule.mobile
        ],
        agentPhone: [
          this.rule.mobile
        ],
        contactsEmail: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        noLoadDraft: [
          { required: true, message: '请输入空载吃水', trigger: 'blur' }
        ],
        fullDraft: [
          { required: true, message: '请输入满载吃水', trigger: 'blur' }
        ],
        noLoadDisplacement: [
          { required: true, message: '请输入空载排水量', trigger: 'blur' }
        ],
        fullDisplacement: [
          { required: true, message: '请输入满载排水量', trigger: 'blur' }
        ],
        navigationArea: [
          { required: true, message: '请输入航区', trigger: 'blur' }
        ]
      },
      isAdd: true,
      addFrom: {
        extList: [
          { type: 1 },
          { type: 2 },
          { type: 3 }
        ],
        delFileIds: []
      },
      flag: true, // 控制组件
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7
        }
      },
      imgList: [],
      zhanshiList: [],
      btnFlg: [],
      btnIdArr: ['00KP002B001', '00KP002B002', '00KP002B003']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/basicData/shipData')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    flagchange () {
      this.$refs.addFrom.clearValidate()
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    // 删除图片
    remove (file) {
      if (file.id) {
        this.addFrom.delFileIds.push(file.id)
      }
    },
    // 获取车辆信息
    blurFn () {
      if (this.isAdd) {
        let shipFlag = this.addFrom.shipInfoFlag
        // if (this.addFrom.shipNo && this.addFrom.shipName) {
        if (this.addFrom.shipName) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cShipInfoDetail({
            // shipNo: this.addFrom.shipNo,
            shipName: this.addFrom.shipName
          }).then(res => {
            loading.close()
            if (res) {
            // console.log(Object.keys(res).length === 0)
            // if (Object.keys(res).length !== 0) {
              this.$set(this.addFrom, 'shipInfoFlag', shipFlag)
              this.addFrom = res.cShipInfo
              this.$set(this.addFrom, 'extList', [
                { type: 1 },
                { type: 2 },
                { type: 3 }
              ])
              res.CShipInfoExt.forEach((item) => {
                this.$set(this.addFrom.extList, item.type - 1, item)
              })
              res.fileList.forEach((item, index) => {
                this.$set(this.imgList, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
              })
            } else {
              this.addFrom = {
                // shipNo: this.addFrom.shipNo,
                shipName: this.addFrom.shipName,
                extList: [
                  { type: 1 },
                  { type: 2 },
                  { type: 3 }
                ]
              }
              this.$set(this.addFrom, 'shipInfoFlag', shipFlag)
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      }
    },
    // 详情
    detailFn (row) {
      this.title = '详情'
      cShipInfoDetail({ id: row.id }).then(res => {
        this.dialogDetail = true
        this.addFrom = res.cShipInfo
        this.$set(this.addFrom, 'extList', [
          { type: 1 },
          { type: 2 },
          { type: 3 }
        ])
        res.CShipInfoExt.forEach((item) => {
          this.$set(this.addFrom.extList, item.type - 1, item)
        })
        this.zhanshiList = []
        res.fileList.forEach((item, index) => {
          this.zhanshiList.push(item.fileUrlOSS)
        })
      })
    },

    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cShipInfoList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = {
        extList: [
          { type: 1 },
          { type: 2 },
          { type: 3 }
        ]
      }
      this.$set(this.addFrom, 'shipInfoFlag', this.options[0].value)
      // console.log(this.addFrom.shipInfoFlag)
      this.dialogVisible = true
      this.isAdd = true
      this.flag = true
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    // 修改
    modifyRegion (row) {
      // if (row.cityName && !row.areaName) {
      //   this.$set(this.addFrom, 'areaCode1', [row.provinceCode, row.cityCode])
      // } else if (!row.cityName && !row.areaName) {
      //   this.$set(this.addFrom, 'areaCode1', [row.provinceCode])
      // } else {
      //   this.$set(this.addFrom, 'areaCode1', [row.provinceCode, row.cityCode, row.areaCode])
      // }
      this.title = '修改'
      cShipInfoDetail({ id: row.id }).then(res => {
        this.dialogVisible = true
        this.isAdd = false
        this.flag = true
        this.addFrom = res.cShipInfo
        this.$set(this.addFrom, 'extList', [
          { type: 1 },
          { type: 2 },
          { type: 3 }
        ])
        this.addFrom.delFileIds = []
        res.CShipInfoExt.forEach((item) => {
          this.$set(this.addFrom.extList, item.type - 1, item)
        })
        res.fileList.forEach((item, index) => {
          this.$set(this.imgList, index, { status: 'ready', url: item.fileUrlOSS, id: item.id })
        })
      })
    },
    saveFn (formName) {
      this.addFrom.isDefault = 1
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          if (this.isAdd) {
            this.addFrom.flag = 1// 代表添加
          } else {
            this.addFrom.flag = 2// 代表修改
          }
          imgfile.set('params', JSON.stringify(this.addFrom))
          let arr = []
          this.imgList.forEach(item => {
            if (!item.id) {
              arr.push(item)
            }
          })
          compressImages(arr, {
            width: 1000
          }).then(result => {
            console.log(result)
            result.forEach(item => {
              imgfile.append('files', item)
            })
            that.save1(imgfile)
          })
        } else {
          return false
        }
      })
    },
    save1 (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cShipInfoAdd(data).then(res => {
        loading.close()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$confirm('是否执行删除操作?', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cShipInfoDelete({ id: selectData[0].id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialog () {
      this.addFrom = {
        extList: [
          { type: 1 },
          { type: 2 },
          { type: 3 }
        ],
        delFileIds: []
      }
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
      this.imgList = []
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
// .imgBox{
//   display: flex;
//   .item{
//     display: flex;
//      width: 50%;
//      justify-content: space-around;
//   }
// }
/deep/.inpBox .el-input__inner{
  width:180px;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.detail /deep/.el-form-item__content{
  width: 150px;
}
// /deep/.NOcommon .el-form-item__label:before {
//     content: "*";
//     color: #f56c6c;
//     margin-right: 4px;
// }
.NOcommon /deep/.el-form-item__label:before{
    display: none;
}
</style>
